import React from "react";
import { MusicHallEventDateFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import moment from "moment";
import { Buttons, Inputs } from "components";

// เลือกได้เฉพาะตัวเลือกที่ลูกค้าเสนอมา (วันหลักที่ขอ + วันสำรอง) แต่ละตัวเลือกมีเวลาของตัวเอง
// requested_booking คือสิ่งที่ลูกค้าขอตอนแรก ไม่ใช่ booking_date ปัจจุบัน เพราะแอดมินอาจย้ายไปแล้ว
const RENDER_DATE_OPTIONS = (
  booking_date,
  alternative_booking_dates,
  requested_booking,
) => {
  const currentKey = moment(booking_date).format("YYYY-MM-DD");
  const items = [
    { option: requested_booking, name: "วันหลักที่ลูกค้าขอ" },
    ...(alternative_booking_dates || []).map((e, i) => ({
      option: e,
      name: `วันสำรอง ${i + 1}`,
    })),
  ];
  const seen = [];
  return items
    .filter((e) => {
      if (!e.option?.booking_date) return false;
      // ตัดวันซ้ำออก เช่น แอดมินย้ายไปวันสำรองแล้ว วันนั้นจะซ้ำกับวันหลักปัจจุบัน
      const key = moment(e.option.booking_date).format("YYYY-MM-DD");
      if (seen.includes(key)) return false;
      seen.push(key);
      return true;
    })
    .map((e) => {
      const key = moment(e.option.booking_date).format("YYYY-MM-DD");
      return {
        value: key,
        label: `${moment(key).format("DD/MM/YYYY")} ${
          e.option.event_start_time
        } - ${e.option.event_end_time} (${e.name}${
          key === currentKey ? " - วันที่ใช้อยู่ตอนนี้" : ""
        })`,
      };
    });
};

const MusicHallEventDateForm = ({
  booking_date,
  requested_booking,
  alternative_booking_dates,
  onBack,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    booking_date: yup.string().required("required"),
    reason: yup.string().required("required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      booking_date: moment(booking_date).format("YYYY-MM-DD"),
      reason: "",
    },
  });

  return (
    <MusicHallEventDateFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="f_tile">เปลี่ยนวันจัดงาน</div>
        <div className="f_sub_tile">
          เลือกได้เฉพาะวันที่ลูกค้าเสนอมาเท่านั้น
        </div>
        <div className="input_wrap date_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Radio
                {...field}
                label={"วันจัดงานจริง"}
                options={RENDER_DATE_OPTIONS(
                  booking_date,
                  alternative_booking_dates,
                  requested_booking,
                )}
                errors={errors.booking_date?.message}
              />
            )}
            name="booking_date"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextArea
                {...field}
                label={"เหตุผลที่เปลี่ยนวัน"}
                placeholder={"ลูกค้าจะเห็นข้อความนี้ในแอป"}
                errors={errors.reason?.message}
              />
            )}
            name="reason"
            defaultValue=""
          />
        </div>
        <div className="action_layout">
          <div className="btn_action_wrap">
            <Buttons.BgStandard theme_gray label="ยกเลิก" onClick={onBack} />
          </div>
          <div className="btn_action_wrap">
            <Buttons.BgStandard theme_purple type="submit" label="บันทึก" />
          </div>
        </div>
      </form>
    </MusicHallEventDateFormStyled>
  );
};

MusicHallEventDateForm.propTypes = {};

export default MusicHallEventDateForm;
